import { KeysOfUnion } from '@utils/types';
import {
  Aggregation,
  Filter,
  Join,
  JoinCondition,
} from '@models/feature-descriptor';
import { AggregationDraft } from './aggregation-draft';
import { FilterDraft } from './filter-draft';
import { JoinDraft } from './join-draft';

export interface FeatureDescriptorDraft {
  join: Record<string, any>;
  filter: Record<string, any>;
  aggregation: Record<string, any>;
}

export namespace FeatureDescriptorDraft {
  export function validate(draft: FeatureDescriptorDraft) {
    const aggregation = AggregationDraft.validate(draft.aggregation);
    const filter = FilterDraft.validate(draft.filter);
    const join = JoinDraft.validate(draft.join);

    return aggregation?.success && filter?.success && join?.success
      ? {
          success: true,
          data: {
            aggregation: aggregation.data,
            filter: filter.data,
            join: join.data,
          },
        }
      : {
          success: false,
          error: {},
        };
  }
}

export interface FeatureDescriptorEditorState extends FeatureDescriptorDraft {
  errors: Record<string, any>;
}

export type FeatureDescriptorDraftFields =
  | `join.${KeysOfUnion<Join>}`
  | KeysOfUnion<JoinCondition>
  | `filter.${KeysOfUnion<Filter>}`
  | `aggregation.${KeysOfUnion<Aggregation>}`;
